import jQuery from "jquery";
import Alert from "bootstrap/js/dist/alert";
import Button from "bootstrap/js/dist/button";
import Carousel from "bootstrap/js/dist/carousel";
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import Popover from "bootstrap/js/dist/popover";
import Scrollspy from "bootstrap/js/dist/scrollspy";
import Tab from "bootstrap/js/dist/tab";
import Toast from "bootstrap/js/dist/toast";
import Tooltip from "bootstrap/js/dist/tooltip";
import Util from "bootstrap/js/dist/util";

window.jQuery = jQuery;
window.$ = jQuery;

// PALBON: a symlinked Rig can expose one dependency under two logical paths during bundling.
// Register every Bootstrap 4 bridge on the browser's authoritative jQuery object explicitly.
for (const [name, Plugin] of Object.entries({
	alert: Alert,
	button: Button,
	carousel: Carousel,
	collapse: Collapse,
	dropdown: Dropdown,
	modal: Modal,
	popover: Popover,
	scrollspy: Scrollspy,
	tab: Tab,
	toast: Toast,
	tooltip: Tooltip,
})) {
	if (Plugin && Plugin._jQueryInterface) {
		jQuery.fn[name] = Plugin._jQueryInterface;
		jQuery.fn[name].Constructor = Plugin;
	}
}

export {
	Util,
	Alert,
	Button,
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	Popover,
	Scrollspy,
	Tab,
	Toast,
	Tooltip,
};
